import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {
  InlineInputGroup, Textarea
} from 'barnyard/components';
import RuleForm from '../inputs/RuleForm';
import InlineItemSelect from '../inputs/InlineItemSelect';
import InlineManufacturerSelect from '../inputs/InlineManufacturerSelect';
import InlineCategorySelect from '../inputs/InlineCategorySelect';
import InlineProductLinesSelect from '../inputs/InlineProductLinesSelect';
import InlineProductSelect from '../inputs/InlineProductSelect';
import InlineSupplierSelect from '../inputs/InlineSupplierSelect';
import InlineRegionSelect from '../inputs/InlineRegionSelect';


const DisableAddToCartsGuidance = (props) => {
  const {
    initialValues,
    onSubmit: propSubmit,
    form,
    ...other
  } = props;
  const corporateName = _.get(other, 'corporate.name', 'corporate');

  const initialState = {
    item_ids: _.join(initialValues.item_ids),
    manufacturer_ids: initialValues.manufacturer_ids || [],
    category_ids: initialValues.category_ids || [],
    product_ids: initialValues.product_ids || [],
    product_line_ids: initialValues.product_line_ids || [],
    supplier_ids: initialValues.supplier_ids || [],
    regions: !_.isEmpty(initialValues.regions) ? initialValues.regions : [0],
    message: initialValues.message
      || `${corporateName} has disabled this item from being added to cart. `
        + `Contact ${corporateName} for further assistance.`,
  };

  const [item_ids, setItemIds] = useState(initialState.item_ids);
  const [manufacturer_ids, setManufacturerIds] = useState(initialState.manufacturer_ids);
  const [category_ids, setCategoryIds] = useState(initialState.category_ids);
  const [product_ids, setProductIds] = useState(initialState.product_ids);
  const [product_line_ids, setProductLineIds] = useState(initialState.product_line_ids);
  const [supplier_ids, setSupplierIds] = useState(initialState.supplier_ids);
  const [regions, setRegions] = useState(initialState.regions);
  const [message, setMessage] = useState(initialState.message);

  const onSubmit = useCallback((event) => {
    event.preventDefault();
    propSubmit({
      kind: 'disable_add_to_carts',
      regions: _.filter(regions),
      value: {
        message,
        item_ids: _.filter(_.map(_.split(item_ids, ','), val => parseInt(val, 10)), val => val),
        manufacturer_ids,
        category_ids,
        product_ids,
        product_line_ids,
        supplier_ids,
      }
    });
  }, [
    item_ids, manufacturer_ids, category_ids, product_ids, product_line_ids,
    supplier_ids, message, propSubmit, regions
  ]);

  const onReset = useCallback(() => {
    setItemIds(initialState.item_ids);
    setManufacturerIds(initialState.manufacturer_ids);
    setCategoryIds(initialState.category_ids);
    setProductIds(initialState.product_ids);
    setProductLineIds(initialState.product_line_ids);
    setSupplierIds(initialState.supplier_ids);
    setRegions(initialState.regions);
    setMessage(initialState.message);
  }, [initialState]);

  return (
    <RuleForm
      {...other}
      onSubmit={onSubmit}
      onReset={onReset}
      isSubmitting={form.is_submitting}
    >
      <InlineRegionSelect
        onChange={setRegions}
        value={regions}
      />
      <InlineSupplierSelect
        mode='multiple'
        label='Suppliers'
        description='Suppliers to disable'
        showSearch={true}
        clearable={true}
        value={supplier_ids}
        placeholder='Suppliers'
        onChange={setSupplierIds}
        include_all={false}
        include_any={false}
      />
      <InlineManufacturerSelect
        mode='multiple'
        label='Manufacturers'
        description='Manufacturers to disable'
        showSearch={true}
        clearable={true}
        value={manufacturer_ids}
        placeholder='Manufacturers'
        onChange={setManufacturerIds}
      />
      <InlineCategorySelect
        mode='multiple'
        label='Categories'
        description='Categories to disable'
        showSearch={true}
        clearable={true}
        value={category_ids}
        placeholder='Categories'
        onChange={setCategoryIds}
        parentOnly={false}
      />
      <InlineProductLinesSelect
        mode='multiple'
        label='Product Lines'
        description='Product lines to disable'
        showSearch={true}
        clearable={true}
        value={product_line_ids}
        placeholder='Product Lines'
        onChange={setProductLineIds}
      />
      <InlineProductSelect
        mode='multiple'
        label='Products'
        description='Products to disable'
        showSearch={true}
        clearable={true}
        value={product_ids}
        placeholder='Products'
        onChange={setProductIds}
      />
      <InlineItemSelect
        description='List of comma separated item ids to disable'
        value={item_ids}
        onChange={setItemIds}
      />
      <InlineInputGroup
        label='Message'
        description='Message to show on the item'
        InputComponent={Textarea}
        value={message}
        onChange={setMessage}
        placeholder='Enter message here...'
      />
    </RuleForm>
  );
};


DisableAddToCartsGuidance.defaultProps = {
  type: 'add',
  initialValues: {},
};

DisableAddToCartsGuidance.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  form: PropTypes.object.isRequired,
  initialValues: PropTypes.object
};

export default DisableAddToCartsGuidance;
